import React, { useState } from 'react';
import { Container, Button, Image, Row, Col, Nav, Dropdown, Badge } from 'react-bootstrap';
import { useNotifications } from '../hooks/useNotifications'; // Assuming useNotifications is set up
import { markAsRead } from '../api/notificationsApi';

function Topbar({ userId }) {
  const { data: notifications = [], isLoading } = useNotifications(userId);
  const unreadCount = notifications.filter(notification => !notification.read).length;
  const [showDropdown, setShowDropdown] = useState(false);

  const handleNotificationClick = async (notificationId) => {
    await markAsRead(userId, notificationId);
  };

  return (
    <Row className='p-2' style={{ backgroundColor: "#154889", borderRadius: '10px', alignItems: "center", justifyContent: "space-between" }}>
      <Col><h4 style={{ color: "white" }}>Dashboard</h4></Col>
      <Col className="d-flex justify-content-end align-items-center">
        <Dropdown show={showDropdown} onToggle={(isOpen) => setShowDropdown(isOpen)}>
          <Dropdown.Toggle as="div" style={{ position: 'relative', cursor: 'pointer' }}>
            <Image src={require('../assets/bell (1).png')} roundedCircle style={{ width: '25px', height: 'auto', marginRight: '5px' }} />
            {unreadCount > 0 && (
              <Badge pill bg="danger" style={{ position: 'absolute', top: '-5px', right: '5px' }}>
                {unreadCount}
              </Badge>
            )}
          </Dropdown.Toggle>

          <Dropdown.Menu align="end" style={{ width: '300px', maxHeight: '400px', overflowY: 'auto' }}>
            {isLoading ? (
              <Dropdown.ItemText>Loading...</Dropdown.ItemText>
            ) : notifications.length > 0 ? (
              notifications.map(notification => (
                <Dropdown.Item
                  key={notification.id}
                  onClick={() => handleNotificationClick(notification.id)}
                  active={!notification.read}
                >
                  {notification.message}
                  <br />
                  <small className="text-muted">{new Date(notification.createdAt.seconds * 1000).toLocaleString()}</small>
                </Dropdown.Item>
              ))
            ) : (
              <Dropdown.ItemText>No new notifications</Dropdown.ItemText>
            )}
          </Dropdown.Menu>
        </Dropdown>
        
        <Image src={require('../assets/user.jpg')} roundedCircle style={{ width: '40px', height: 'auto' }} />
      </Col>
    </Row>
  );
}

export default Topbar;
